const comments = [
  {
    name: '追剧小天使',
    time: '2天前',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20portrait-style%20avatar%20with%20soft%20lighting%2C%20neutral%20background%2C%20gentle%20expression%2C%20modern%20Asian%20aesthetic%2C%20clean%20and%20simple%20composition&width=120&height=120&seq=wuma-avatar-01&orientation=squarish',
    text: '午马影院真的是我今年发现的宝藏网站！画质超清晰，更新速度也快，每天晚上追《长安如故》从没卡顿过，强烈推荐给所有追剧党！',
    rating: 5,
  },
  {
    name: '影视爱好者',
    time: '3天前',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20portrait-style%20avatar%20with%20soft%20lighting%2C%20neutral%20background%2C%20friendly%20expression%2C%20modern%20Asian%20aesthetic%2C%20clean%20and%20simple%20composition&width=120&height=120&seq=wuma-avatar-02&orientation=squarish',
    text: '片库真的太全了，从经典老剧到最新热播应有尽有。不用注册就能直接看，这点太良心了。《深渊之光》全剧没有一处广告打扰，观影体验满分。',
    rating: 5,
  },
  {
    name: '深夜追剧人',
    time: '5天前',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20portrait-style%20avatar%20with%20soft%20lighting%2C%20neutral%20background%2C%20warm%20expression%2C%20modern%20Asian%20aesthetic%2C%20clean%20and%20simple%20composition&width=120&height=120&seq=wuma-avatar-03&orientation=squarish',
    text: '手机端适配做得很好，通勤路上也能流畅追剧。最喜欢每日更新动态功能，再也不用到处搜罗剧集更新信息了，一个网站全搞定。',
    rating: 5,
  },
  {
    name: '古装控小王',
    time: '1周前',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20portrait-style%20avatar%20with%20soft%20lighting%2C%20neutral%20background%2C%20bright%20expression%2C%20modern%20Asian%20aesthetic%2C%20clean%20and%20simple%20composition&width=120&height=120&seq=wuma-avatar-04&orientation=squarish',
    text: '作为一个古装剧爱好者，午马影院的古装片库深得我心！《九州风云录》特效太震撼了，高清画质下每一帧都像壁纸，已经安利给身边所有朋友。',
    rating: 5,
  },
  {
    name: '剧荒终结者',
    time: '1周前',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20portrait-style%20avatar%20with%20soft%20lighting%2C%20neutral%20background%2C%20calm%20expression%2C%20modern%20Asian%20aesthetic%2C%20clean%20and%20simple%20composition&width=120&height=120&seq=wuma-avatar-05&orientation=squarish',
    text: '终于找到一个不弹广告的追剧站了！热门话题区还能看到大家的讨论，找剧再也不迷茫。希望午马越来越好，持续更新更多好剧！',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-3">
            用户好评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            听听追剧达人们怎么说午马影院
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.slice(0, 3).map((item, index) => (
            <div
              key={index}
              className="p-5 md:p-6 rounded-2xl border border-background-200 bg-background-50"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-primary-400 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {item.text}
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200">
                <div className="w-9 h-9 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {comments.slice(3).map((item, index) => (
            <div
              key={index}
              className="p-5 md:p-6 rounded-2xl border border-background-200 bg-background-50"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-primary-400 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {item.text}
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200">
                <div className="w-9 h-9 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}